import React, { Component } from "react";
import { List, ListItem, ListItemText, TextField } from "@mui/material";
import { Spinner } from "reactstrap";

import "./BanksList.css";
import { UserBank } from "../../../../generated";

export class BankListItem extends Component<
  {
    onClick: (bank: UserBank) => void;
    value: UserBank;
  },
  {}
> {
  render() {
    return (
      <ListItem
        button
        onClick={() => this.props.onClick(this.props.value)}
        divider={true}
        disableGutters={true}
      >
        <ListItemText
          primary={this.props.value.displayName}
          secondary={this.props.value.legalName}
        />
      </ListItem>
    );
  }
}

export interface BankListProps {
  banks: UserBank[];
  onClick: (bank: UserBank) => void;
  hidden: boolean;
}

export class BanksList extends Component<
  BankListProps,
  {
    searchInput: string;
    searchWaiting: boolean;
    searchInProgress: boolean;
  }
> {
  private typingTimeout: NodeJS.Timeout = null;

  constructor(props: BankListProps) {
    super(props);
    this.state = {
      searchInput: "",
      searchWaiting: true,
      searchInProgress: false,
    };
  }

  filter(banks: UserBank[]) {
    return banks.filter(
      (b) =>
        this.state.searchInput === "" ||
        (b.legalName &&
          b.legalName.toLowerCase().includes(this.state.searchInput)) ||
        (b.displayName &&
          b.displayName.toLowerCase().includes(this.state.searchInput))
    );
  }

  searchOnChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    let searchingInput = (event.target as HTMLTextAreaElement).value;
    clearTimeout(this.typingTimeout);

    this.setState({
      searchInProgress: true,
    });

    this.typingTimeout = setTimeout(() => {
      this.setState({
        searchInput: searchingInput.toLowerCase(),
        searchInProgress: false,
        searchWaiting: false,
      });
    }, 500);
  };

  render() {
    return (
      <div hidden={this.props.hidden}>
        <TextField
          id="standard-search"
          label="Find a bank ..."
          type="search"
          fullWidth
          onChange={this.searchOnChange}
        />
        {this.state.searchWaiting === true ? (
          <></>
        ) : (
          <List style={{ maxHeight: 600, overflow: "auto" }}>
            {this.state.searchInProgress ? (
              <Spinner />
            ) : (
              this.filter(this.props.banks).map((bank, index) => (
                <BankListItem
                  key={index}
                  value={bank}
                  onClick={this.props.onClick}
                />
              ))
            )}
          </List>
        )}
      </div>
    );
  }
}
